module.exports = __webpack_public_path__ + "static/media/lang2.8340de6d.mp3";